export class CountdownTimer
{
    timers = document.querySelectorAll('[data-s~="CountdownTimer"]')

    calculate(endtime)
    {
        endtime = parseInt(endtime+"000")

        let distance = endtime - new Date().getTime()

        let days = Math.floor(distance / (1000 * 60 * 60 * 24))
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        let seconds = Math.floor((distance % (1000 * 60)) / 1000)

        return {
            distance,
            days,
            hours,
            minutes,
            seconds,
        }
    }

    register(e, endtime)
    {
        const days = e.querySelector('[data-s~="CountdownTimer:days"]')
        const hours = e.querySelector('[data-s~="CountdownTimer:hours"]')
        const minutes = e.querySelector('[data-s~="CountdownTimer:minutes"]')
        const seconds = e.querySelector('[data-s~="CountdownTimer:seconds"]')

        let interval = setInterval(() => {
            let date = this.calculate(endtime)

            if (date.distance < 0) {
                clearInterval(interval)

                days.textContent = 0
                hours.textContent = 0
                minutes.textContent = 0
                seconds.textContent = 0
            } else {
                days.textContent = date.days
                hours.textContent = date.hours
                minutes.textContent = date.minutes
                seconds.textContent = date.seconds
            }
        }, 1000)
    }

	watch()
	{
        this.timers.forEach(e => {
            this.register(e, e.getAttribute("data-date"))
		})
	}
}
